export default "__VITE_ASSET__54e0eb0c__"